import { Switch } from '@headlessui/react'
import { Controller } from 'react-hook-form';
import SwitchInput from './SwitchInput';

function DestinationSwitch({ name, control, disabled, onChange: onValueChange, ariaLabel }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, onBlur } }) => (
        <Switch
          checked={value}
          onChange={(val) => {
            onChange(val);
            if (onValueChange) onValueChange(val);
          }}
          onBlur={onBlur}
          disabled={disabled}
          className={`group relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${disabled ? "bg-zinc-200/60 data-[checked]:bg-primary-300/70" : "bg-zinc-200 data-[checked]:bg-primary"}`}
        >
          <span className="sr-only">{ariaLabel}</span>
          <span
            aria-hidden="true"
            className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
          />
        </Switch>
      )}
    />
  );
}

// A single notification field with two independent destination toggles. The Email / Portal
// captions live once per section (see NotificationChannelColumns), so each switch sits bare in a
// column that lines up beneath its header. With the portal flag off there is only one destination,
// so we fall back to the original single-switch row.
export default function NotificationToggleRow({
  emailName,
  portalName,
  showPortal,
  emailDisabled,
  portalDisabled,
  emailControl,
  portalControl,
  onEmailChange,
  onPortalChange,
  children,
}) {
  if (!showPortal) {
    return (
      <SwitchInput
        name={emailName}
        control={emailControl}
        disabled={emailDisabled}
        onChange={onEmailChange}
      >
        {children}
      </SwitchInput>
    );
  }

  return (
    <div className="flex items-start justify-between gap-4 sm:gap-8">
      <div className="flex max-w-md flex-col items-start">{children}</div>
      <div className="flex shrink-0 items-center gap-8 pt-0.5">
        <div className="flex w-14 justify-center">
          <DestinationSwitch
            name={emailName}
            control={emailControl}
            disabled={emailDisabled}
            onChange={onEmailChange}
            ariaLabel="Email"
          />
        </div>
        <div className="flex w-14 justify-center">
          <DestinationSwitch
            name={portalName}
            control={portalControl}
            disabled={portalDisabled}
            onChange={onPortalChange}
            ariaLabel="Portal"
          />
        </div>
      </div>
    </div>
  );
}

// The Email / Portal column headers, shown once per section and aligned to the switch columns
// above. Rendered only when the portal destination is available.
export function NotificationChannelColumns() {
  return (
    <div className="flex shrink-0 items-center gap-8">
      <span className="w-14 text-center text-xs font-semibold uppercase tracking-wide text-zinc-400">
        Email
      </span>
      <span className="w-14 text-center text-xs font-semibold uppercase tracking-wide text-zinc-400">
        Portal
      </span>
    </div>
  );
}
